/* tslint:disable */
/* eslint-disable */
/**
 * MG-DX Patient API
 * API for Patient
 *
 * The version of the OpenAPI document: 0.2.0
 * Contact: developers@mg-dx.co.jp
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { tzDate } from "@mgdx-libs/dayjs";
import { exists, mapValues } from "../runtime";

export const PostMemoRequestBodyTypename = "PostMemoRequestBody" as const;

/**
 *
 * @export
 * @interface PostMemoRequestBody
 */
export interface PostMemoRequestBody {
  /**
   *
   * @type {string}
   * @memberof PostMemoRequestBody
   */
  content?: string;
  /**
   * Resource type name
   * @type {string}
   * @memberof PostMemoRequestBody
   */
  readonly __typename?: string;
}

export function PostMemoRequestBodyFromJSON(json: any): PostMemoRequestBody {
  return PostMemoRequestBodyFromJSONTyped(json, false);
}

export function PostMemoRequestBodyFromJSONTyped(json: any, ignoreDiscriminator: boolean): PostMemoRequestBody {
  if (json === undefined || json === null) {
    return json;
  }
  return {
    __typename: PostMemoRequestBodyTypename,

    content: !exists(json, "content") ? undefined : json["content"],
  };
}

export function PostMemoRequestBodyToJSON(object?: PostMemoRequestBody | null): any {
  if (object === undefined) {
    return undefined;
  }
  if (object === null) {
    return null;
  }
  const { __typename, ...value } = object;
  return {
    content: value.content,
  };
}
